import { DatePicker, Table } from 'antd';
import { useEffect, useState } from 'react';
import { backendUrl } from '../../Config';
import { useSearchParams } from "react-router-dom";
import { ajaxFetchCall } from '../../services/ApiService';
import { appendKey, convertToGraphQl, createGraphQlFilters, createSortOrder } from '../../services/GarphQlConversionService';
import { createTableFilters } from '../../services/TableFilter';
import { Tag } from 'antd';
import MyDatePicker from '../antdCommon/DatePicker';
import moment from 'moment';
import Tags from '../tags/tags';
import { getDateRange } from '../../utils/date_range_util';
import { getDateParams, getDefaultPagination, getFilterParams, getPaginationParams, getSorterParams, setQueryParams, updateColumnsFilter } from '../../utils/state_query_param_util';
import { getColumns, getGraphQlItems } from './config';
import { Flex } from 'antd/es';

export default function MutualFund(props) {
    const [searchParams, setSearchParams] = useSearchParams();
    const { RangePicker } = MyDatePicker;
    const [dataSource, setDataSource] = useState([])
    const graphqlName = "GrowwMutualFundPagination"
    const [defaultFilterDate, setDefaultFilterDate] = useState([moment().subtract(5, 'years'), moment()])

    let [loading, setLoading] = useState(false)
    const [dateDefaultValue, setDateDefaultValue] = useState(getDateParams(searchParams))

    const [pagination, setPagination] = useState(getDefaultPagination(searchParams))

    const [filters, setFilters] = useState(getFilterParams(searchParams))

    const [sorter, setSorter] = useState(getSorterParams(searchParams))

    const graphQlItems = getGraphQlItems()

    const [columns, setColumns] = useState(getColumns(filters));

    useEffect(() => {
        getData()
        setQueryParams(setSearchParams, filters, pagination, sorter, dateDefaultValue)
    }, [dateDefaultValue, defaultFilterDate, filters, sorter])

    useEffect(async () => {
        let fundNamePromise = ajaxFetchCall(backendUrl + "/distinct/" + "growwmutualfunds/" + "fund_name")
        let fundHousePromise = ajaxFetchCall(backendUrl + "/distinct/" + "growwmutualfunds/" + "fund_house")
        let categoryPromise = ajaxFetchCall(backendUrl + "/distinct/" + "growwmutualfunds/" + "category")
        let subCategoryPromise = ajaxFetchCall(backendUrl + "/distinct/" + "growwmutualfunds/" + "sub_category")

        Promise.all([fundNamePromise, fundHousePromise, categoryPromise, subCategoryPromise]).then(async (values) => {
            let tempCols = [...columns]
            tempCols[1]["filters"] = createTableFilters(values[0]["response"])
            tempCols[2]["filters"] = createTableFilters(values[1]["response"])
            tempCols[3]["filters"] = createTableFilters(values[2]["response"])
            tempCols[4]["filters"] = createTableFilters(values[3]["response"])

            setColumns(tempCols)
            // await getData()
        });
    }, [])


    const getData = async () => {
        let sort = createSortOrder(sorter)
        let graphqlFilters = createGraphQlFilters(filters)

        let q1 = convertToGraphQl(graphqlName, graphqlFilters, graphQlItems, sort, pagination.current, pagination.pageSize)

        let body = JSON.stringify({
            query: q1
        });
        setLoading(true)
        let data = await ajaxFetchCall(backendUrl + "/graphql", {
            method: "POST",
            body: body
        })
        appendKey(data["data"][graphqlName]["items"])
        let mutualFunds = data["data"][graphqlName]["items"].map((item) => item._id)
        let returnQuery = `mutualFund=${mutualFunds}&start=${dateDefaultValue[0].toISOString()}&end=${dateDefaultValue[1].toISOString()}&navStartWith=${defaultFilterDate[0].toISOString()}`
        let returns = await ajaxFetchCall(backendUrl + "/mutualFund/returns?" + returnQuery)
        for (let l of data["data"][graphqlName]["items"]) {
            let filterData = returns["response"].filter((item) => {
                return item._id == l._id
            })
            if (filterData && filterData.length != 0) {
                l["start"] = filterData[0].start
                l["end"] = filterData[0].end
                l["startDate"] = new Date(filterData[0].startDate).toLocaleDateString()
                l["endDate"] = new Date(filterData[0].endDate).toLocaleDateString()
                l["returns"] = (100 * (l["end"] - l["start"]) / l["start"]).toFixed(2)

                let mStart = moment(filterData[0].startDate)
                let mEnd = moment(filterData[0].endDate)
                let days = mEnd.diff(mStart, 'days')
                if (days != 0) {
                    let ci = (100 * 365 * (
                        (
                            (Math.pow((l["end"] / l["start"]), 1 / (days))) - 1
                        )
                    )).toFixed(2)
                    l["ci"] = ci
                } else {
                    l["ci"] = 0
                }
            } else {
                l["returns"] = 0
                l["ci"] = 0
            }
        }
        let actualFunds = []
        for (let l of data["data"][graphqlName]["items"]) {
            if (l["start"] && l["end"]) {
                actualFunds.push(l)
            }
        }
        setLoading(false)
        setDataSource(actualFunds)

        let tempPagination = { ...pagination }
        tempPagination["total"] = data["data"][graphqlName].count
        setPagination(tempPagination)

    }

    const onChange = (pagination, filters, sorter, extra) => {
        setPagination(pagination)
        setFilters(filters)
        setColumns(updateColumnsFilter(columns, filters))
        setSorter(sorter)
    }

    const dateChange = (dates) => {
        setDateDefaultValue(dates)
    }
    const filterDateChange = (dates) => {
        setDefaultFilterDate(dates)
    }

    return (
        <div>
            <Flex justify="space-between">
                <RangePicker
                    presets={
                        getDateRange()
                    }
                    defaultValue={dateDefaultValue} onChange={dateChange} />
                <RangePicker presets={getDateRange()} defaultValue={defaultFilterDate} onChange={filterDateChange}>

                </RangePicker>
            </Flex>
            <Tags tags={filters}></Tags>
            <Table loading={loading} scroll={{ x: 1500, y: 1500 }} dataSource={dataSource} columns={columns} onChange={onChange} pagination={pagination} />
        </div >

    );
}
